import { Routes } from '~/api/api-routes'

import axios from '../axiosBase'

export const onboardingService = {
  getProductCategories(storeId) {
    try {
      return axios.get(Routes.onboarding.getProductCategories(storeId))
    } catch (error) {
      console.log(error)
    }
  },
  getProductsFromCategories(categoryIds = [], storeId) {
    try {
      return axios.get(Routes.onboarding.getProductsFromCategories(storeId), {
        params: { category_ids: categoryIds },
      })
    } catch (error) {
      console.log(error)
    }
  },
  addToImportList(payload = [], storeId) {
    try {
      return axios.post(Routes.onboarding.addToImportList(storeId), {
        productIds: payload,
      })
    } catch (error) {
      console.log(error)
    }
  },
  importToStore(payload = [], storeId) {
    try {
      return axios.post(Routes.onboarding.importToStore(storeId), {
        productIds: payload,
      })
    } catch (error) {
      console.log(error)
    }
  },

  getWizardCategories() {
    try {
      return axios.get(Routes.onboarding.getCategories)
    } catch (error) {
      console.log(error)
    }
  },

  getWizardProducts(categoryIds) {
    try {
      return axios.get(Routes.onboarding.getProducts, {
        params: { categoryIds },
      })
    } catch (error) {
      console.log(error)
    }
  },

  setupStore(payload, storeId) {
    try {
      return axios.post(Routes.onboarding.setupStore(storeId), payload)
    } catch (error) {
      console.log(error)
    }
  },

  getSetupStatus(storeId, themeRequestId) {
    try {
      return axios.get(Routes.onboarding.setupStore(storeId), {
        params: { themeRequestId },
      })
    } catch (error) {
      console.log(error)
    }
  },

  async sendTrackProgress(currentStep) {
    try {
      return await axios.post(Routes.onboarding.trackProgress, {
        currentStep,
      })
    } catch (error) {
      console.error(error)
      return null
    }
  },
  async subscribeMarketingDeal(payload) {
    try {
      return await axios.post(Routes.onboarding.deal, payload)
    } catch (error) {
      console.log(error)
    }
  },
}

export default onboardingService
